import { Helmet } from "react-helmet-async";
import { useI18n } from "@/i18n/I18nProvider";

export default function Seo({ title, description, image, jsonLd, noindex }) {
  const { t } = useI18n();
  const full = title ? `${title} | ${t("brand.name")}` : `${t("brand.name")} — ${t("brand.slogan")}`;
  const desc = description || t("hero.subtitle");
  const url = typeof window !== "undefined" ? window.location.origin + window.location.pathname + window.location.search : "";
  return (
    <Helmet>
      <title>{full}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={full} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content={t("brand.name")} />
      {image && <meta property="og:image" content={image} />}
      {noindex && <meta name="robots" content="noindex" />}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
